module.exports = __webpack_public_path__ + "img/bg_L.2b59f7bb.png";